import Button from 'components/Button'
import Text from 'components/Text'
import { View } from 'components/View'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import PlusButton from 'pages/Workout/components/PlusButton'
import workoutMessages from 'modules/workout/redux/messages'
import React from 'react'
import useIntl from 'modules/component/utils/hooks/useIntl'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'

/**
 * @param index
 * @param style
 * @param roundsSetData
 * @param handleClickCreateRound
 * @param handleClickRound
 * @param isSelected
 * @returns {JSX.Element}
 * @constructor
 */
const Round = ({
  index,
  style,
  roundsSetData,
  handleClickCreateRound,
  handleClickRound,
  isSelected
}) => {
  const intl = useIntl()
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)
  const isLast = index === roundsSetData.length

  if (
    isLast &&
    !handleClickCreateRound
  ) {
    return <></>
  }

  if (isLast) {
    return (
      <View
        px={0}
        style={style}
        ml={isSmallScreen ? 1 : 0}
      >
        <PlusButton onClick={handleClickCreateRound} />
      </View>
    )
  }

  let marginLeft
  if (isSmallScreen) {
    marginLeft = '0.5rem'
  } else {
    marginLeft = 0
  }

  return (
    <View
      px={0}
      style={style}
      ml={marginLeft}
    >
      <Button
        onClick={() => handleClickRound(index)}
        style={{
          width: 'unset',
          height: 'unset',
          maxWidth: 'unset'
        }}
      >
        <View
          w='98px'
          centered
          py='8px'
          bgc={isSelected ? '#F6F6F6' : '#ffffff'}
          style={{
            borderRadius: '6px',
            border: isSelected
              ? '1px solid #F6F6F6'
              : '1px solid #DDDDDD'
          }}
        >
          <Text
            c={isSelected ? '#151D21' : '#7F8D94'}
            fw='520'
            fs='13px'
          >{formatMessageIntlUtil(intl, workoutMessages.round)} {index + 1}
          </Text>
        </View>
      </Button>
    </View>
  )
}

export default Round
